import { EditSchoolDTO, SchoolDTO } from './school-profile.dto';
import { RootState } from '../../store/reducers';

export const selectCurrentSchoolProfile = (state: RootState): EditSchoolDTO | SchoolDTO => state.schoolProfile;
